import TimingType from '../store/schema/TimeSuggestionsTimingTypes';
import { now, addWeeks, DisplayDate, isBefore } from 'owa-datetime';
import { createWeekDateRange, DateRange, createDateRange } from 'owa-datetime-utils';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

const THIRTY_DAYS = 30;

export function getTimeRangeFromTimingSearchCriteria(
    startDate: DisplayDate,
    timingOption: TimingType
): DateRange {
    const today = now();
    // If startDate is in the past, start with today's date instead
    const startTime = isBefore(startDate, today) ? today : startDate;
    const userWeekStartDay = getUserConfiguration()?.UserOptions?.WeekStartDay || 0;
    switch (timingOption) {
        case TimingType.ThisWeek:
            const weekRange = createWeekDateRange(userWeekStartDay, startTime);
            // Don't return a start date that happens in the past
            if (isBefore(weekRange.start, today)) {
                weekRange.start = today;
            }
            return weekRange;
        case TimingType.NextWeek:
            const nextWeekRange = createWeekDateRange(userWeekStartDay, addWeeks(startTime, 1));
            return nextWeekRange;
        case TimingType.NextAvailable:
        default:
            return createDateRange(startTime, THIRTY_DAYS);
    }
}
